'use client'

import BrandLogoSwap from './partner/BrandLogoSwap'
import UserMenu from './UserMenu'
import { usePartnerBranding } from '@/hooks/usePartnerBranding'

/**
 * Top navigation bar for the phone-width app shell (see ConditionalLayout).
 * Just the logo and the user profile menu — primary navigation is
 * intentionally absent on mobile; the shell only exposes the dashboard and
 * the assistant chat strip. The user menu carries the org switcher
 * (showOrgSwitcher) since this bar is the only chrome on mobile.
 */
export default function MobileTopNav() {
  // Same partner-branding swap as the sidebar: partner-affiliated orgs see
  // the partner's logo instead of the 42a chrome.
  const branding = usePartnerBranding()

  return (
    <header
      className="flex items-center justify-between px-4 py-2 border-b flex-shrink-0"
      style={{
        background: 'var(--color-sidebar)',
        borderColor: 'var(--color-border)',
      }}
    >
      <BrandLogoSwap
        partnerLogoUrl={branding?.logoUrl}
        partnerLogoDarkUrl={branding?.logoDarkUrl}
        width={110}
        height={32}
      />
      <UserMenu collapsed dropdownDirection="down" dropdownAlign="right" hideDesktopOnlyLinks showOrgSwitcher />
    </header>
  )
}
